"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section ref={ref} className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image & Gradient */}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1475502/img/hero_freelancer_home_office_natural_light.png)] transition-transform duration-[2000ms] ease-out" style={{
      transform: isVisible ? "scale(1.05)" : "scale(1)"
    }}>
        <div className="absolute inset-0 bg-gradient-to-r from-dark-background/40 via-dark-background/30 to-dark-background/20" />
      </div>

      {/* Hero Content */}
      <div className={`relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center max-w-7xl mx-auto">
          {/* Text */}
          <div className="text-left space-y-6 mb-10">
            <p className="text-lg sm:text-xl lg:text-2xl text-white font-bold leading-tight font-display">
              Problem Solved. Revenue Delivered.
            </p>
            <p className="text-base sm:text-lg lg:text-xl text-white/95 leading-relaxed max-w-2xl font-sans">
              I help publishers keep digital advertising campaigns running smoothly, producing outcomes that meet advertiser expectations and support revenue growth. From ad operations and analytics to conversion tracking and CMP compliance, I handle the technical details so your teams can focus on strategy, sales, and marketing.
            </p>
            <p className="text-base sm:text-lg lg:text-xl text-white/95 leading-relaxed max-w-2xl font-sans">
              With over 20 years of experience, I make complex systems reliable for both internal teams and advertisers, ensuring accurate data, dependable delivery, and results teams can trust.
            </p>
          </div>

          {/* CTA Button */}
          <div className="flex justify-start lg:justify-end">
            <Button asChild size="lg" className="group relative overflow-hidden bg-[#2EAF7D] hover:bg-[#2EC98F] text-white font-semibold text-base sm:text-lg px-8 py-6 rounded-md shadow-soft hover:shadow-medium transition-all duration-[80ms] hover:scale-[1.02] active:bg-[#27A06B] active:scale-100 focus-ring">
              <Link to="/ContactPage">
                <span className="relative z-10 flex items-center gap-2">
                  Connect
                  <ArrowRight className="size-5 transition-transform duration-[var(--duration-fast)] group-hover:translate-x-1" />
                </span>
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}